/**
 * Legacy clamps every quota metric display the same way: a negative value
 * (which can happen transiently while a field is mid-update server-side)
 * reads as 0, and anything past 9999 reads as a dash rather than a long
 * number — see manage-quotas.component.ts:910-923 (`manageCap`).
 */
export const capQuotaNumber = (value: number): number | '-' => {
  if (value < 0) return 0;
  if (value > 9999) return '-';
  return value;
};
